import { Typography, TypographyVariants } from '@carboledger/ui';
import { X } from '@carboledger/ui/icons';
import styles from './LinkedTag.module.scss';

/**
 * Props:
 *   label        the linked record's reference id
 *   removeLabel  accessible name for the ✕
 *   onRemove     () => void; omit to render the tag read-only
 */
export const LinkedTag = ({ label, removeLabel, onRemove }) => (
  <div className={styles.tag}>
    <Typography variant={TypographyVariants.bodySm}>{label}</Typography>
    {onRemove ? (
      <button type="button" className={styles.remove} aria-label={removeLabel} onClick={onRemove}>
        <X size={16} />
      </button>
    ) : null}
  </div>
);
